const types = {
  // ── Listagem / Filtro ──────────────────────────────────────
  FILTER_AGENDAMENTOS:         "agendamento/FILTER_AGENDAMENTOS",
  FILTER_AGENDAMENTOS_SUCCESS: "agendamento/FILTER_AGENDAMENTOS_SUCCESS",
  FILTER_AGENDAMENTOS_FAILURE: "agendamento/FILTER_AGENDAMENTOS_FAILURE",

  // ── Criar ─────────────────────────────────────────────────
  CREATE_AGENDAMENTO:         "agendamento/CREATE_AGENDAMENTO",
  CREATE_AGENDAMENTO_SUCCESS: "agendamento/CREATE_AGENDAMENTO_SUCCESS",
  CREATE_AGENDAMENTO_FAILURE: "agendamento/CREATE_AGENDAMENTO_FAILURE",

  // ── Editar ────────────────────────────────────────────────
  UPDATE_AGENDAMENTO:         "agendamento/UPDATE_AGENDAMENTO",
  UPDATE_AGENDAMENTO_SUCCESS: "agendamento/UPDATE_AGENDAMENTO_SUCCESS",
  UPDATE_AGENDAMENTO_FAILURE: "agendamento/UPDATE_AGENDAMENTO_FAILURE",

  // ── Deletar ───────────────────────────────────────────────
  DELETE_AGENDAMENTO:         "agendamento/DELETE_AGENDAMENTO",
  DELETE_AGENDAMENTO_SUCCESS: "agendamento/DELETE_AGENDAMENTO_SUCCESS",
  DELETE_AGENDAMENTO_FAILURE: "agendamento/DELETE_AGENDAMENTO_FAILURE",

  RESET_SUCCESS: "@agendamento/RESET_SUCCESS",
};

export default types;
